module.exports = __webpack_public_path__ + "img/chevron-right-small.fbb8ef7e.svg";